import React from "react"
import { TextMediaSliderContainer } from "containers"
import Hyperlink from "components/hyperlink"
import { withDynamicComponents } from "higher-order-components"
import { Button } from "AtomicComponents"

const TextMediaSliderBlock = props => <TextMediaSliderContainer {...props} />

TextMediaSliderBlock.displayName = "InteractiveSlideshowBlock" // @CMS-CHANGE InteractiveSlideshowBlock => TextMediaSliderBlock

export default TextMediaSliderBlock



// WEBPACK FOOTER //
// ./src/blocks/text-media-slider/index.jsx